import styled, { css } from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Button = styled(BaseButton)<{ isMobileView: boolean }>`
    padding: 12px 24px;
    ${FONTS.XS};
  
    ${p => p.isMobileView && css`
        width: 100%;
    `}
`;
